//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';
import type { LinkElementProps } from '../internalComponents/RCFavoriteCard/RCFavoriteCard';
import { RCFavoriteCard } from '../internalComponents/RCFavoriteCard/RCFavoriteCard';
import RCSavedSearchThumbnailFallbackImage from '../../images/componentHelpers/RCSavedSearchThumbnailFallback.svg';

interface RCSavedSearchCardProps {
  additionalContent: React.ReactElement;
  linkElement: (children: React.ReactNode) => React.ReactElement<LinkElementProps>;
  secondaryAction?: React.ReactElement;
  subtitle: string;
  thumbnailURL: string;
  title: string;
  verticalStretch?: boolean;
  watchButtonElement?: React.ReactElement;
  clickableCard?: boolean;
}

export function RCSavedSearchCard({
  additionalContent,
  linkElement,
  secondaryAction = undefined,
  subtitle,
  thumbnailURL,
  title,
  verticalStretch = false,
  watchButtonElement = undefined,
  clickableCard = true,
}: RCSavedSearchCardProps) {
  return (
    <RCFavoriteCard
      additionalContent={additionalContent}
      linkElement={linkElement}
      primaryAction={watchButtonElement}
      secondaryAction={secondaryAction}
      subtitle={subtitle}
      thumbnailURL={thumbnailURL || RCSavedSearchThumbnailFallbackImage}
      title={title}
      type="search"
      verticalStretch={verticalStretch}
      clickableCard={clickableCard}
    />
  );
}
